import { Collapse } from "antd";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { HolderOutlined } from "@ant-design/icons";
import styles from "../statusList.module.scss";

const { Panel } = Collapse;

export const SortableStatusItem = ({
  status,
  isAssessment,
  isBlocked,
  expandedStatusIds,
  onStatusExpanded,
  scrollRef,
  children,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: status.id, disabled: !isAssessment });

  return (
    <div
      ref={(el) => {
        setNodeRef(el);
        scrollRef?.(el);
      }}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : isBlocked ? 0.4 : 1,
        cursor: isBlocked ? "not-allowed" : undefined,
        pointerEvents: isBlocked ? "none" : undefined,
      }}
    >
      <Collapse
        expandIconPosition="end"
        className={styles.customCollapse}
        activeKey={expandedStatusIds.includes(status.id) ? status.id : null}
        onChange={() => onStatusExpanded(status.id)}
      >
        <Panel
          key={status.id}
          header={
            isAssessment ? (
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <HolderOutlined
                  style={{ color: "rgba(0,0,0,0.45)", cursor: "grab" }}
                  {...listeners}
                  {...attributes}
                  onClick={(e) => e.stopPropagation()}
                />
                {status.name}
              </div>
            ) : (
              status.name
            )
          }
        >
          {children}
        </Panel>
      </Collapse>
    </div>
  );
};
